import filter from "lodash/filter";
import { PanelItem, SidePanelType, useSidePanelsStore } from "PFApp/stores/side_panels_store";
import { useShallow } from "zustand/react/shallow";

import { DetailsPanelData } from "../details_panel.types";

export const useOpenedDetailsPanels = (): PanelItem<DetailsPanelData>[] =>
  useSidePanelsStore(
    useShallow((state) => filter(state.panels, ({ key }) => key.startsWith(SidePanelType.BookingDetails)))
  );
